import gql from 'graphql-tag';
import { userShoppingCartFragment } from '../fragments';

const userShoppingCartQuery = gql`
  query userShoppingCartQuery($_id: ID!) {
    userShoppingCart(_id: $_id) {
      ...userShoppingCartFragment
    }
  }
  ${userShoppingCartFragment}
`;

export default userShoppingCartQuery;
